import { IShip } from '../../../data/types/ship/ship';
import { getMaxHullStrength } from './hull-strength';

export const getHullToRepair = (ship: IShip): number =>
  getMaxHullStrength(ship) - ship.hull;
